import React, {Component} from 'react';
import OcenyTable from "./OcenyTable";


export default class OcenySzczegoloweTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {

        return (
            <div>
                <OcenyTable data={this.props.ocenySzczeglowe}/>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/oceny/components/OcenySzczegoloweTab.js